import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ChannelContainer from '../containers/channel/ChannelContainer';
import ReceiverContainer from '../containers/receiver/ReceiverContainer';
import DeliveryLogsContainer from '../containers/distribution_logs/DeliveryLogsContainer';
import APISettingsMenu from '../pages/distribution/APISettingsMenu';
import AdoptionImportContainer from '../containers/distribution/AdoptionImportContainer';
import LoadSheetsContainer from '../containers/load_sheets/LoadSheetsContainer';
import { ApplicationState } from '../reducers';
import { isPDMUser } from '../utils/UserUtils';

const ChannelRoutes = () => {
  const user = useSelector((state: ApplicationState) => state.user.user);
  const isLoadSheetsAllowed = React.useMemo(() => isPDMUser(user!), [user]);

  return (
    <Routes>
      <Route path="history" element={<DeliveryLogsContainer />} />
      <Route path="channels" element={<ChannelContainer />} />
      <Route path="receiver" element={<ReceiverContainer />} />
      <Route path="api/*" element={<APISettingsMenu />} />
      <Route path="import/*" element={<AdoptionImportContainer />} />
      {isLoadSheetsAllowed && <Route path="load-sheets" element={<LoadSheetsContainer />} />}
    </Routes>
  );
};

export default ChannelRoutes;
